import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useToast } from "../context/ToastContext";
import { Button, Field, Input } from "../components/ui";

export default function Login() {
  const { user, login } = useAuth();
  const toast = useToast();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const onSubmit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      await login(form);
      toast.success("Welcome back");
    } catch (error) {
      toast.error(error.message || "Email or password is wrong");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-art" aria-hidden="true">
        <div className="login-house" />
      </div>
      <form className="login-card" onSubmit={onSubmit}>
        <div className="brand login-brand">
          <span className="brand-mark">B</span>
          <div>
            <strong>Builder Books</strong>
            <small>Customers, installments, daily cash</small>
          </div>
        </div>
        <h1>Welcome</h1>
        <p className="lead">Sign in to see your cashbook.</p>
        <Field label="Email">
          <Input
            type="email"
            required
            autoComplete="email"
            value={form.email}
            onChange={(event) => setForm((prev) => ({ ...prev, email: event.target.value }))}
            placeholder="name@email.com"
          />
        </Field>
        <Field label="Password" hint="At least 8 characters">
          <Input
            type="password"
            required
            minLength={8}
            autoComplete="current-password"
            value={form.password}
            onChange={(event) => setForm((prev) => ({ ...prev, password: event.target.value }))}
            placeholder="••••••••"
          />
        </Field>
        <Button type="submit" className="full" disabled={busy}>
          {busy ? "Please wait..." : "Sign in"}
        </Button>
      </form>
    </div>
  );
}
